import React from 'react';
import { format, parseISO, isValid } from 'date-fns';
import { fr } from 'date-fns/locale';
import { Calendar as CalendarIcon } from 'lucide-react';
import { Button } from './button';
import { Calendar } from './calendar';
import { Popover, PopoverContent, PopoverTrigger } from './popover';

/**
 * Sélecteur de date au format français (jj/mm/aaaa) basé sur le Calendar shadcn.
 * `value` / `onChange` manipulent une chaîne ISO 'YYYY-MM-DD' (compat backend).
 */
export function DatePickerFr({ value, onChange, placeholder = 'jj/mm/aaaa', className = '', minToday = false, id }) {
  const selected = value && isValid(parseISO(value)) ? parseISO(value) : undefined;

  const handleSelect = (date) => {
    onChange(date ? format(date, 'yyyy-MM-dd') : '');
  };

  const disabled = minToday
    ? (date) => date < new Date(new Date().setHours(0, 0, 0, 0))
    : undefined;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          id={id}
          variant="outline"
          className={`h-9 justify-start text-left font-normal bg-white ${!selected ? 'text-slate-400' : 'text-slate-900'} ${className}`}
          data-testid="date-picker-fr-trigger"
        >
          <CalendarIcon className="h-4 w-4 mr-2 opacity-70" />
          {selected ? format(selected, 'dd/MM/yyyy', { locale: fr }) : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={handleSelect}
          disabled={disabled}
          locale={fr}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}

export default DatePickerFr;
